import logo from '@/logos/webex.png';

import type { ImageProps } from './types';

export const WebexLogo = (props: ImageProps) => {
  return <img {...props} src={logo} alt='Webex' />;
};
